var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFolderSolid = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "var(--icon-primary, currentColor)",
  d: "M10.453 4.31a1.929 1.929 0 0 1 1.182.577l1.739 1.8c.101.104.235.16.368.16h4.413c.683 0 1.333.28 1.809.772.474.491.737 1.152.737 1.836v4.546a.7.7 0 0 1-.7.7h-16a.7.7 0 0 1-.7-.7v-7.09c0-.685.262-1.347.737-1.838a2.52 2.52 0 0 1 1.809-.772h4.414z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--icon-secondary, currentColor)",
  d: "M18.155 9.39c.683 0 1.333.281 1.809.773.475.491.737 1.152.737 1.837v5.09c0 .685-.262 1.347-.737 1.838a2.52 2.52 0 0 1-1.809.772H5.847c-.683 0-1.333-.28-1.809-.772a2.64 2.64 0 0 1-.737-1.837V12c0-.684.262-1.346.737-1.837a2.52 2.52 0 0 1 1.809-.772z"
})));
export default SvgFolderSolid;